import React from 'react';
import { DocumentBlock } from '../ast/document.types';
import { TextBlockRenderer } from './blocks/TextBlockRenderer';
import { FormulaBlockRenderer } from './blocks/FormulaBlockRenderer';
import { TableBlockRenderer } from './blocks/TableBlockRenderer';
import { ImageBlockRenderer } from './blocks/ImageBlockRenderer';
import { ShapeBlockRenderer } from './blocks/ShapeBlockRenderer';
import { PageBreakBlockRenderer } from './blocks/PageBreakBlockRenderer';

interface BlockRendererProps {
  block: DocumentBlock;
}

export const BlockRenderer: React.FC<BlockRendererProps> = ({ block }) => {
  switch (block.type) {
    case 'text':
      return <TextBlockRenderer block={block} />;
    case 'formula':
      return <FormulaBlockRenderer block={block} />;
    case 'table':
      return <TableBlockRenderer block={block} />;
    case 'image':
      return <ImageBlockRenderer block={block} />;
    case 'shape':
      return <ShapeBlockRenderer block={block} />;
    case 'page_break':
      return <PageBreakBlockRenderer block={block} />;
    default:
      return (
        <div style={{ padding: '8px', color: '#dc2626', fontSize: '11px', border: '1px dashed #fca5a5' }}>
          Unknown block type: {(block as any).type}
        </div>
      );
  }
};
